import { __awaiter } from 'tslib';
import { im_proto } from '../../proto/index.js';
import * as Long from 'long';
import { SdkConsts } from '../consts.js';
import { getUrl } from './urls.js';
import { ContextClassBase } from '../service/RuntimeContext.js';

var RequestTracing;
(function (RequestTracing) {
    RequestTracing[RequestTracing["RequestCreate"] = 0] = "RequestCreate";
    RequestTracing[RequestTracing["RequestSerialize"] = 1] = "RequestSerialize";
    RequestTracing[RequestTracing["BeforeSend"] = 2] = "BeforeSend";
    RequestTracing[RequestTracing["BeforeSendSingleFlight"] = 3] = "BeforeSendSingleFlight";
    RequestTracing[RequestTracing["AfterSendSingleFlight"] = 4] = "AfterSendSingleFlight";
    RequestTracing[RequestTracing["AfterSend"] = 5] = "AfterSend";
    RequestTracing[RequestTracing["ResponseDeserialize"] = 6] = "ResponseDeserialize";
    RequestTracing[RequestTracing["SendMethod"] = 7] = "SendMethod";
})(RequestTracing || (RequestTracing = {}));
function generaterSeqId() {
    let seq = 10000;
    return () => {
        seq += 1;
        return seq;
    };
}
const getSeqId = generaterSeqId();
class NetworkItem extends ContextClassBase {
    constructor(ctx, cmd, req, seqId) {
        super(ctx);
        this.retryTimes = 0;
        this.seqId = seqId !== null && seqId !== void 0 ? seqId : getSeqId();
        this.reqBody = req;
        this.cmd = cmd;
        const path = getUrl(cmd);
        let endpoint = this.ctx.option.apiUrl;
        if (!endpoint.endsWith('/')) { // in case endpoint not end with /
            endpoint = endpoint + '/';
        }
        this.url = endpoint + path;
    }
    get logid() {
        var _a, _b;
        return (_b = (_a = this.response) === null || _a === void 0 ? void 0 : _a.log_id) !== null && _b !== void 0 ? _b : '';
    }
    prepareRequest(inboxType) {
        return __awaiter(this, void 0, void 0, function* () {
            let req = im_proto.Request.create({
                body: this.reqBody,
                cmd: this.cmd,
                sequence_id: Long.fromNumber(this.seqId),
                refer: SdkConsts.refer,
                token: this.ctx.cachedToken,
                headers: this.ctx.option.headers,
                device_id: this.ctx.option.deviceId,
                sdk_version: SdkConsts.sdkVersion,
                build_number: SdkConsts.buildNumber,
                inbox_type: inboxType,
                device_platform: this.ctx.option.devicePlatform,
                channel: this.ctx.option.channel,
                device_type: this.ctx.option.deviceType,
                os_version: this.ctx.option.osVersion,
                version_code: this.ctx.option.versionCode,
                auth_type: this.ctx.option.authType,
                biz: this.ctx.option.biz,
                access: SdkConsts.requestAccessName
            });
            // 修改 body 的钩子
            for (const plugin of this.ctx.plugin) {
                req = yield plugin.sendPacket(req);
            }
            this.request = req;
        });
    }
}

export { NetworkItem };
//# sourceMappingURL=NetworkItem.js.map
